import { NavigationRefs } from 'components/infosite/navigation/navigation-refs.tsx';

import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { LocalizedComponentProps, LocalizedText } from 'bernie-l10n';
import { QueryRoute, RouteStore } from 'bernie-core';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { UitkCard, UitkCardContent, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkSecondaryButton } from 'uitk-react-button';

import { ReviewsDialogLayer } from './reviews-dialog-layer';
import { ReviewsListOnInfosite } from 'components/infosite/property-details/reviews-list-on-infosite';
import { ReviewsSummary } from 'components/infosite/property-details/reviews-summary';

export interface ReviewsOnInfositeProps extends LocalizedComponentProps {
  routeStore?: RouteStore;
  currentHotel?: CurrentHotelStore;
}

const ButtonTracked = ClickTracker(UitkSecondaryButton);

@inject('routeStore')
@observer
export class ReviewsOnInfosite extends React.Component<ReviewsOnInfositeProps, any> {
  private reviewsButtonRef;
  public constructor(props) {
    super(props);
    this.state = {
      initialized: false
    };

    this.openReviewsDialog = this.openReviewsDialog.bind(this);
    this.onReviewsDialogClosed = this.onReviewsDialogClosed.bind(this);
  }

  public componentDidMount() {
    this.setState({ initialized: true });
  }

  private openReviewsDialog() {
    const { routeStore } = this.props;
    routeStore.updateSearch({ pwaDialog: 'see-all-reviews-dialog' });
  }

  private onReviewsDialogClosed() {
    // Close the reviews dialog
    this.props.routeStore.goBack();
    // Return focus to the button that opened the dialog
    this.reviewsButtonRef.focus();

    return;
  }

  public render() {
    const { initialized } = this.state;
    const searchCriteria = this.props.currentHotel && this.props.currentHotel.searchCriteria;
    const refsMapReviews = NavigationRefs.Reviews;
    const refFocus = reviewsAction => {
      this.reviewsButtonRef = reviewsAction;
    };

    return (
      <div ref={refsMapReviews}>
        <UitkCard data-stid="reviews-on-infosite">
          <UitkCardContent>
            <UitkCardTextSegment>
              <div className="xl-x-padding-three xl-y-padding-three">
                <div className="uitk-grid all-x-gutter-six">
                  <div className="uitk-cell all-cell-1-3 m-cell-1-1 s-cell-1-1">
                    <h2 className="is-visually-hidden">
                      <LocalizedText message="hotels.infosite.reviews.title" />
                    </h2>
                    <ReviewsSummary />
                  </div>
                  <div className="uitk-cell all-cell-2-3 m-cell-1-1 s-cell-1-1">
                    <ReviewsListOnInfosite />
                    <ButtonTracked
                      domRef={refFocus}
                      onClick={this.openReviewsDialog}
                      linkName="See All Reviews"
                      rfrr="Reviews.ClickSeeAllReviewsToOpenDialog"
                      events="event419=10"
                      text={<LocalizedText message="hotels.infosite.reviews.seeAllReviews" />}
                      data-stid="see-all-reviews"
                      disabled={!initialized}
                    />
                  </div>
                </div>
              </div>
            </UitkCardTextSegment>
          </UitkCardContent>
        </UitkCard>
        <QueryRoute query={{ pwaDialog: 'see-all-reviews-dialog' }}>
          <ReviewsDialogLayer onReviewsDialogClosed={this.onReviewsDialogClosed} searchCriteria={searchCriteria} />
        </QueryRoute>
      </div>
    );
  }
}
